import { render, staticRenderFns } from "./first.vue?vue&type=template&id=181bbc97&scoped=true&"
import script from "./first.vue?vue&type=script&lang=js&"
export * from "./first.vue?vue&type=script&lang=js&"
import style1 from "./first.vue?vue&type=style&index=1&id=181bbc97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181bbc97",
  null
  
)

export default component.exports